export const SelectEventType = {
  SELECT_AUTO_NOTES_LANGUAGE_IN_VIDEO_NOTE_PAGE: "Select AUTO-NOTES LANGUAGE in Video note page",
};
